import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../teamschat-dialog.action';
import { TeamschatDialogState } from '../teamschat-dialog.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: TeamschatDialogState,
    action: PayloadAction<ActionType, Reload>,
): TeamschatDialogState {
    return {
        ...state,
    };
}

export function reloadResultReducer(
    state: TeamschatDialogState,
    action: PayloadAction<ActionType, ReloadResult>,
): TeamschatDialogState {
    const nextChatMember = action.payload.chat?.members?.find(
        (e) => e.userId === action.payload.userId,
    );

    return {
        ...state,
        chat: action.payload.chat,
        chatMember: nextChatMember,
        errorCode: action.payload.errorCode,
        hasPendingData: action.payload.errorCode === 0,
    };
}
